import useWorkspace from './use-workspace';
import { totalDays } from '@/lib/helpers';

export default function useIsCancelled() {
  const { workspace } = useWorkspace();

  return workspace?.plan_end_date && totalDays(workspace.plan_end_date) < 0;
}
